var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full flex items-center justify-center "},[_vm._v(" Sign out! ")])}
var staticRenderFns = []

export { render, staticRenderFns }